var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bday)?_c('div',{staticClass:"bday-box"},[_c('p',[_vm._v("Happy Birthday "+_vm._s(_vm.bday))])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }